// Module
var code = " <div title=\"{{ 'PLANNED_SLOT' | translate }} {{$ctrl.item.repeatSet.id}}\"> <span class=\"planned-slot-title\">{{ 'PLANNED_SLOT' | translate }} {{$ctrl.item.repeatSet.id}}</span> <div class=\"hover\"> <sis-icon icon=\"place-ring-fill\" [icon-class]=\"'ccw-90'\"></sis-icon><span translate=\"TIMELINE.TIME_HERE\"></span> </div> </div> ";
// Exports
module.exports = code;